import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateOrUpdateMultiRequestDiscountMutationRequest, CreateOrUpdateMultiRequestDiscountMutationResponse, CreateOrUpdateMultiRequestDiscountPathParams, CreateOrUpdateMultiRequestDiscount400, CreateOrUpdateMultiRequestDiscount404, CreateOrUpdateMultiRequestDiscount500 } from "../types/CreateOrUpdateMultiRequestDiscount";

/**
 * @summary Создание/обновление скидки
 * @link /api/multirequests/:multiRequestId/discounts
 */

export function useCreateOrUpdateMultiRequestDiscount <TData = CreateOrUpdateMultiRequestDiscountMutationResponse, TError = CreateOrUpdateMultiRequestDiscount400 | CreateOrUpdateMultiRequestDiscount404 | CreateOrUpdateMultiRequestDiscount500, TVariables = CreateOrUpdateMultiRequestDiscountMutationRequest>(multiRequestId: CreateOrUpdateMultiRequestDiscountPathParams["multiRequestId"], options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/multirequests/${multiRequestId}/discounts`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
